import { createRouter, createWebHistory } from 'vue-router'
import LoginView from '../views/LoginView.vue'
import ConfigView from '../views/ConfigView.vue'
import DashboardView from '../views/DashboardView.vue'
import DashboardClientiView from '../views/DashboardClientiView.vue'
import DocumentiView from '../views/DocumentiView.vue'
import TabelleView from '../views/TabelleView.vue'
import UtentiView from '../views/UtentiView.vue'

const routes = [
  {
    path: '/',
    name: 'login',
    component: LoginView
  },
  {
    path: '/configurazioni',
    name: 'configurazioni',
    component: ConfigView
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: DashboardView
  },
  {
    path: '/dashboard-clienti',
    name: 'dashboard-clienti',
    component: DashboardClientiView
  },
  {
    path: '/documenti/:iddoc?/:idtipo?',
    name: 'documenti',
    component: DocumentiView
  },
  {
    path: '/tabelle',
    name: 'tabelle',
    component: TabelleView
  },
  {
    path: '/utenti',
    name: 'utenti',
    component: UtentiView
  },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
